import route from "@/components/router/Router"

export default {
    path : "company-administrative-area",
    name : "company-administrative-area",
    meta : {
        title : "行政区划管理",
    },
    redirect : {
        name : "company-administrative-area-edit",
    },
    component: route,
    children : [
        {
            path: 'edit',
            name: 'company-administrative-area-edit',
            meta: {
                title: '行政区划管理-单位管理'
            },
            component: () => import('@/pages/company/administrativeArea/Index'),
        },
    ]
}







// WEBPACK FOOTER //
// ./src/router/company/administrativeArea/index.js